<template>
  <ViewCustomData entityName="facility_flange" entitySpec="data" serviceName="BaseService"
    :columns="FACILITY_FLANGE_COLUMNS" :masterDetail="{ facility_id: facilityId }" ref="viewFacilityFlange"
    :paginator="false" mode="edit" :requiredFieldsTable="{
      flange_no: true,
      meter_factor: true,
      switch_flange_time: true,
    }" :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert" :prepareData="prepareData"
    :beforeOpenNewRow="beforeOpenNewRow" />
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { FACILITY_FLANGE_COLUMNS } from './facilityConstants';

const props = defineProps({
  facilityId: {
    type: [Number, String],
    required: true,
  },
})

const emit = defineEmits(['loadData']);

const viewFacilityFlange = ref(null);

const prepareUpdate = (rowData) => {
  return {
    flange_id: rowData.flange_id,
    flange_no: rowData.flange_no,
    meter_factor: rowData.meter_factor,
    switch_flange_time: rowData.switch_flange_time,
    flange_actual: rowData.flange_actual,
    facility_id: props.facilityId,
  }
}

const prepareInsert = (rowData) => {
  delete rowData.switch_flange_time_hour;
  delete rowData.hanger_names;
  return rowData;
}

const beforeOpenNewRow = (rowData) => {
  rowData.flange_id = null;
  rowData.meter_factor = 1;
  rowData.flange_actual = true;
  rowData.facility_id = props.facilityId;
}

const prepareData = (data) => {
  emit('loadData', data, 'FacilityFlange');
  return data.map((item) => ({
    flange_id: item.flange_id,
    facility_flange_id: item.facility_flange_id,
    flange_no: item.flange_no,
    meter_factor: item.meter_factor,
    switch_flange_time: item.switch_flange_time,
    switch_flange_time_hour: item.switch_flange_time_hour,
    flange_actual: item.flange_actual,
    hanger_names: item.hanger_names,
  }));
}

</script>
